import React from "react";
import { observer } from "mobx-react";
import { UserDeviceActivityTemplate } from "themes/administration/analytics/pages";
import { UserDeviceActivityViewStore } from "administration/analytics/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) => new UserDeviceActivityViewStore(rootStore, componentProps),
    "userDeviceActivityViewStore"
)
@observer
class UserDeviceActivity extends React.Component {
    render() {
        return <UserDeviceActivityTemplate {...this.props} />;
    }
}

export default UserDeviceActivity;
